import { all, takeEvery, put, call } from 'redux-saga/effects';
import { keyByProperty } from '../../../../helpers/core';
import Api from '../../../../helpers/api';
import notifications from '../../../../redux/notifications/actions';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import actions from './actions';

const statesApi = new Api('states/list?pageSize=99');
const findAssociateApi = new Api('applicants/transfer_associate/lookup');
const beginBackgroundCheckApi = new Api('applicants/transfer_associate/background_check');

function* loadAssociateFormDataRequest() {
  try {
    // Load states for State Leave dropdown
    const result = yield call(sendRequest, statesApi.load, {}, notifications.REQUEST_ERROR);

    yield put(
      actions.loadAssociateFormDataSuccess({
        states: result.data.data.map(item => ({ name: item.code, id: item.id })),
      }),
    );
  } catch (error) {
    logger.error(error);
  }
}

function* findAssociateRequest({ payload }) {
  try {
    const { findAssociateForm } = payload;
    const findAssociateFormPropsArray = Object.values(findAssociateForm);
    const associate = keyByProperty(findAssociateFormPropsArray, 'name', prop => prop.value);

    const { pernr, ssn } = associate;
    // "Sync project" requires only last 4 digits of ssn
    const syncSsn = ssn.substr(ssn.length - 4);

    // Lookup Associate
    const result = yield call(
      sendRequest,
      findAssociateApi.multipleParamsCreateItem,
      { data: { lookup: { employee_id: pernr, ssn: syncSsn } } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.base && result.base) {
      yield put(actions.findAssociateError({ data: result.base[0] }));
    } else if (result && result.data) {
      const { data } = result;

      Object.assign(data, {
        pernr,
        sick_hours_attributes: data.sick_hours || [],
        cost_center: '',
        pto_hours_accrued: 0,
      });

      yield put(actions.findAssociateSuccess({ associateData: data }));
      yield put(actions.setStep(2));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* beginBackgroundCheckRequest({ payload }) {
  try {
    const { confirmAssociateForm } = payload;

    const confirmAssociateFormPropsArray = Object.values(confirmAssociateForm);
    const confirmAssociate = keyByProperty(confirmAssociateFormPropsArray, 'name', prop => prop.value);

    // Send all data from lookup response beside `pernr` property
    delete confirmAssociate.pernr;

    const result = yield call(
      sendRequest,
      beginBackgroundCheckApi.multiparamsUpdateItem,
      {
        data: {
          background_check: { ...confirmAssociate },
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result?.data) {
      const { data } = result;
      yield put(actions.beginBackgroundCheckSuccess({ id: data.id }));
      yield put(actions.setStep(3));
    } else {
      yield put(actions.beginBackgroundCheckFail(result));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_ASSOCIATE_FORM_DATA_REQUEST, loadAssociateFormDataRequest)]);
  yield all([takeEvery(actions.FIND_ASSOCIATE_REQUEST, findAssociateRequest)]);
  yield all([takeEvery(actions.BEGIN_BACKGROUND_CHECK_REQUEST, beginBackgroundCheckRequest)]);
}
